export interface Review {
  id: string;
  name: string;
  avatar: string;
  content: string;
  rating: number;
  date: string;
  location: string;
}

export const reviews: Review[] = [
  {
    id: 'rev-1',
    name: '李雨桐',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20friendly%20smile%2C%20clean%20peach%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-rev-1&orientation=squarish',
    content: '用了8x8x水蜜桃快两年了，资源更新速度真的快，界面也很清爽，推荐给身边好多朋友了。客服响应也及时，遇到问题基本都能快速解决。',
    rating: 5,
    date: '2026-07-30',
    location: '北京',
  },
  {
    id: 'rev-2',
    name: '王浩然',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20confident%20expression%2C%20clean%20peach%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-rev-2&orientation=squarish',
    content: '分类很全，搜索功能也好用，找资源特别方便。2026新版更新后体验更好了，播放器流畅度明显提升，离线缓存功能也很实用。',
    rating: 5,
    date: '2026-07-28',
    location: '上海',
  },
  {
    id: 'rev-3',
    name: '张思雨',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20gentle%20smile%2C%20clean%20peach%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-rev-3&orientation=squarish',
    content: '作为创作者入驻半年了，收益透明结算准时，数据后台也很专业。平台对创作者的扶持力度很大，推荐机制也比较公平。',
    rating: 4,
    date: '2026-07-25',
    location: '广州',
  },
  {
    id: 'rev-4',
    name: '刘子轩',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%2C%20casual%20friendly%20look%2C%20clean%20peach%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-rev-4&orientation=squarish',
    content: '免费资源真的很丰富！每天逛逛免费专区都能发现好东西。积分任务也不难完成，基本每周都能兑换到足够的观看时长。',
    rating: 5,
    date: '2026-07-22',
    location: '深圳',
  },
  {
    id: 'rev-5',
    name: '陈晓芳',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20bright%20smile%2C%20clean%20peach%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-rev-5&orientation=squarish',
    content: '社区氛围很好，评论区大家都挺友善的。有时候看评论比看内容还有意思哈哈。平台活动也很有趣，上次参加投票活动还中了奖。',
    rating: 5,
    date: '2026-07-20',
    location: '成都',
  },
  {
    id: 'rev-6',
    name: '周明辉',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%2C%20mature%20professional%2C%20clean%20peach%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-rev-6&orientation=squarish',
    content: '安全性做得不错，之前担心个人信息泄露，用了这么久发现平台在隐私保护方面确实用心。双重验证功能让人很安心。',
    rating: 4,
    date: '2026-07-18',
    location: '杭州',
  },
];